<template>
    <div class="Aviso">
        <div class="libe_home_nav" v-if="scroll >= 88">
            <headNav :activeNav="'loan'"></headNav>
        </div>
        <div class="libe_home_wrap">
            <div class="libe_homenav" v-if="scroll < 88 ">
                <headNav :activeNav="'loan'"></headNav>
            </div>

            <div class="empresa_dvw">
                <div class="empresa_m">
                    <img src="@/assets/img/empresa_01.webp" alt="">
                </div>
                <div class="empresa_dx">
                    <div class="empresa_bt">Introducción de empresa</div>
                    <div class="empresa_dp">AmigoCredi es una plataforma de préstamos en efectivo en línea centrada en las necesidades de los usuarios, especializada en resolver el problema de las dificultades financieras para los usuarios mexicanos. Estamos decididos a desarrollar diferentes soluciones de préstamos de acuerdo con las diferentes necesidades de los usuarios, y proporcionar a los usuarios servicios que puedan resolver el uso de los fondos.</div>
                </div>
            </div>
        </div>
        <footPage></footPage>
    </div>
</template>

<script>

    import $ from 'jquery';
    import headNav from "@/components/headNav.vue";
    import footPage from "@/components/foot.vue";
    import "../components/scss/Aviso.scss";

    export default {
        name: "loan",
        components: { headNav, footPage },
        data() {
            return {
                scroll: 0,
                activeName: 'first',
            }
        },
        mounted(){
            document.documentElement.scrollTop = 0;
            window.addEventListener('scroll',this.handleScroll);
            if(this.$route.query.activeName){
                this.activeName = this.$route.query.activeName;
            }
            this.$nextTick(() => {
                $('.el-tabs__active-bar').css({
                    width: '150px'
                })
            });


        },
        methods: {
            handleClick(tab, event){
                console.log(tab)
                console.log(event)
                this.$nextTick(() => {
                    setTimeout(() => {
                        $('.el-tabs__active-bar').css({
                            width: '150px'
                        })
                    }, 100)
                });
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop||document.body.scrollTop
            },
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style lang="scss">
    .empresa_dvw{
        width: 100%;
        height: 1115px;
        background: #0F0000;
        position:relative;
        overflow:hidden;
        box-sizing: border-box;
        padding: 93px 0 0 0;
        .empresa_dx{
            width: 100%;
            height: auto;
            box-sizing: border-box;
            padding: 104px 0 0 0;
            position: absolute;
            .empresa_bt{
                width: 100%;
                height: 127px;
                font-weight: bold;
                font-size: 60px;
                color: #FFFFFF;
                line-height: 82px;
                text-align: center;
                font-style: normal;
                text-transform: none;
            }
            .empresa_dp{
                width: 890px;
                height: auto;
                margin: 0 auto;
                font-weight: 400;
                font-size: 16px;
                color: rgba(239,237,253,0.7);
                line-height: 24px;
                text-align: center;
                font-style: normal;
                text-transform: none;
            }
        }
    }
    .empresa_m{
        width: 1920px;
        height: 1022px;
        position:absolute;
        left:50%;
        margin-left:-960px;
        img{
            display: block;
            width: 100%;
        }
    }
</style>

